import { PERMISSION_GROUPS, PERMISSION_LABELS } from "@/pages/admin/users/permissions";

interface PermissionPickerProps {
  selected: string[];
  onToggle: (code: string) => void;
  onSelectAll: () => void;
  onClear: () => void;
}

export default function PermissionPicker({
  selected,
  onToggle,
  onSelectAll,
  onClear,
}: PermissionPickerProps) {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center justify-between gap-3">
        <p className="text-xs font-semibold text-foreground-700">Permisos del usuario</p>
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={onSelectAll}
            className="whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-2.5 py-1 text-xs font-semibold text-foreground-800 hover:bg-background-100"
          >
            Todos
          </button>
          <button
            type="button"
            onClick={onClear}
            className="whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-2.5 py-1 text-xs font-semibold text-foreground-800 hover:bg-background-100"
          >
            Ninguno
          </button>
        </div>
      </div>

      {PERMISSION_GROUPS.map((group) => (
        <div key={group.title} className="rounded-lg border border-background-200 bg-background-100 p-3">
          <div className="mb-2.5 flex items-center gap-2">
            <span className="flex h-5 w-5 items-center justify-center text-foreground-500">
              <i className={`${group.icon} text-base`}></i>
            </span>
            <p className="text-xs font-semibold uppercase tracking-wide text-foreground-600">
              {group.title}
            </p>
          </div>
          <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
            {group.codes.map((code) => {
              const checked = selected.includes(code);
              return (
                <button
                  key={code}
                  type="button"
                  onClick={() => onToggle(code)}
                  className={`flex items-center gap-2.5 rounded-md border px-3 py-2 text-left text-sm transition-colors ${
                    checked
                      ? "border-primary-300 bg-primary-50 text-primary-900"
                      : "border-background-200 bg-background-50 text-foreground-700 hover:bg-background-100"
                  }`}
                >
                  <span
                    className={`flex h-4 w-4 shrink-0 items-center justify-center rounded border ${
                      checked ? "border-primary-500 bg-primary-500 text-background-50" : "border-background-300"
                    }`}
                  >
                    {checked ? <i className="ri-check-line text-[11px]"></i> : null}
                  </span>
                  <span className="truncate">{PERMISSION_LABELS[code] || code}</span>
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}